<template>
  <v-col cols="12">
    <div>
      <naj-box
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.sectionTitle"
      >
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.socialId"
              :value.sync="formModel.socialId"
              :disabled="isChecking || (formModel.isHeirsDataRetrieved && formModel.socialId) || viewMode"
              validates="required"
              @input="socialIdChanged"
            ></naj-input>
          </v-col>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.instrumentNumber"
              :value.sync="formModel.instrumentNumber"
              :disabled="isChecking || viewMode"
              validates="required"
              @input="instrumentNumberChanged"
            ></naj-input>
          </v-col>
          <v-col
            cols="4"
            align-self="center"
            class="text-right"
          >
            <naj-button
              v-if="isCheckButtonVisible"
              square
              :loading="isChecking"
              :disabled="isCheckButtonDisabled || viewMode"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <div>
      <naj-box
        ref="deceasedSection"
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.deceasedSectionTitle"
      >
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.deceasedNameLabel"
              :value.sync="formModel.deceasedFullName"
              :disabled="viewMode"
              validates="required"
            ></naj-input>
          </v-col>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.deceasedDeathDateLabel"
              :value.sync="formModel.deceasedDeathDate"
              :disabled="viewMode"
              validates="required"
            ></naj-input>
          </v-col>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.radioButton"
              :label="locales.deceasedGenderLabel"
              :value.sync="formModel.deceasedGender"
              :items="sex"
              :disabled="viewMode"
              item-value="id"
              item-text="name"
              validates="required"
            ></naj-input>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <heirs-grid
      :form-model="formModel"
      :root-form-model="rootFormModel"
      :view-mode="viewMode"
    ></heirs-grid>
  </v-col>
</template>

<script>
import HeirsGrid, { RELATIONSHIP_DATA_SOURCE } from './heirs-grid';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers(
  'GlobalModule'
);
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
export default {
  name: 'CheckHeirsData',
  components: { HeirsGrid },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isChecking: false,
      isManual: false,
    };
  },
  computed: {
    ...mapLUTState(['sex']),
    locales() {
      return this.local.dynamicFormAdmin.customComponents.checkHeirsData;
    },
    isCheckButtonDisabled() {
      return (
        !this.formModel.socialId ||
        !this.formModel.instrumentNumber ||
        this.isChecking
      );
    },
    isCheckButtonVisible() {
      return !this.formModel.isHeirsDataRetrieved || this.isChecking;
    },
    isFieldDisabled() {
      return this.isManual || this.isChecking;
    },
  },
  methods: {
    ...mapGlobalActions(['getDeceasedAndHeirsData']),
    check() {
      this.isChecking = true;
      this.resetForm();
      this.getDeceasedAndHeirsData({
        requestCode: this.formModel.instrumentNumber,
        socialId: this.formModel.socialId,
      })
        .then((res) => {
          if (res.data) {
            this.$set(this.formModel, 'isHeirsDataRetrieved', true);
            this.toaster.success(this.local.common.verificationSucceeded);
            const mappedData = {
              deceasedFullName: res.data.deceased.fullName,
              deceasedDeathDate: res.data.deceased.deathDate,
              deceasedGender: res.data.deceased.genderId,
              socialId: res.data.deceased.socialId,
              heirsData: this.mapHeirsData(res.data.allHeirs),
            };
            Object.keys(mappedData)
              .map((key) => {
                this.$set(this.formModel, key, mappedData[key]);
                return key;
              });
          }
        })
        .catch(() => {
          this.isManual = true;
          this.toaster.error(this.local.common.noData);
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    resetForm() {
      if (this.formModel.isHeirsDataRetrieved) {
        this.$set(this.formModel, 'heirsData', null);
        this.$set(this.formModel, 'deceasedGender', null);
        this.$set(this.formModel, 'deceasedDeathDate', null);
        this.$set(this.formModel, 'deceasedFullName', null);
        this.$refs.deceasedSection.$validator.reset();
      }
      this.$set(this.formModel, 'isHeirsDataRetrieved', false);
      this.isManual = false;
    },
    instrumentNumberChanged() {
      this.resetForm();
    },
    socialIdChanged() {
      this.resetForm();
    },
    resolveHeirStatus(statusId, statusName, genderId) {
      const STATUS_NAME_TO_KEY = {
        'راشد': 1, 'قاصر سناً': 2, ' قاصر سناً': 2, 'قاصر سنا': 2,
        'قاصر عقلاً': 3, 'قاصر عقلا': 3, 'متوفى': 4, 'متوفي': 4,
      };
      const MALE = { 1: 'راشد', 2: ' قاصر سناً', 3: 'قاصر عقلاً', 4: 'متوفى' };
      const FEMALE = { 1: 'راشدة', 2: 'قاصرة سنًا', 3: 'قاصرة عقلًا', 4: 'متوفية' };
      let key = statusId;
      if (!key && statusName) {
        key = STATUS_NAME_TO_KEY[statusName.trim()] || null;
      }
      if (!key) return { key: null, name: statusName || null };
      const isFemale = Number(genderId) === 2;
      const name = isFemale ? (FEMALE[key] || statusName) : (MALE[key] || statusName);
      return { key, name };
    },
    resolveRelationship(serviceName) {
      if (serviceName == null || serviceName === '') return { id: null, name: null };
      const trimmed = String(serviceName).trim();
      // If the service returns a numeric id (e.g. 7 or "7"), look up by id
      const numVal = Number(trimmed);
      if (!isNaN(numVal) && String(numVal) === trimmed) {
        const match = RELATIONSHIP_DATA_SOURCE.find(item => item.id === numVal);
        if (match) return { id: match.id, name: match.name };
      }
      const map = {
        'أب': { id: 1, name: 'أبيه' }, 'الأب': { id: 1, name: 'أبيه' },
        'أم': { id: 7, name: 'أمه' }, 'الأم': { id: 7, name: 'أمه' },
        'ابن': { id: 2, name: 'ابنه' }, 'الابن': { id: 2, name: 'ابنه' },
        'ابنة': { id: 3, name: 'ابنته' }, 'الابنة': { id: 3, name: 'ابنته' },
        'أخ': { id: 5, name: 'أخوه' }, 'الأخ': { id: 5, name: 'أخوه' },
        'الأخ الشقيق': { id: 18, name: 'أخيه الشقيق' },
        'الأخ لأم': { id: 30, name: 'أخيه لأم' },
        'الأخ لأب': { id: 29, name: 'أخيه لأبيه' },
        'أخت': { id: 8, name: 'أخته' }, 'الأخت': { id: 8, name: 'أخته' },
        'الأخت الشقيقة': { id: 19, name: 'أخته الشقيقة' },
        'الأخت لأم': { id: 59, name: 'أخته لأمه' },
        'الأخت لأب': { id: 50, name: 'أخته لأبيه' },
        'زوج': { id: 74, name: 'زوج أمه' }, 'الزوج': { id: 74, name: 'زوج أمه' },
        'زوجة': { id: 9, name: 'زوجته' }, 'الزوجة': { id: 9, name: 'زوجته' },
        'العم': { id: 11, name: 'عمه' }, 'العمة': { id: 38, name: 'عمته' },
        'الخال': { id: 4, name: 'خاله' }, 'الخالة': { id: 22, name: 'خالته' },
        'الجد': { id: 58, name: 'جده' },
        'ابن الابن': { id: 25, name: 'ابن ابنه' },
        'بنت الابن': { id: 24, name: 'بنت ابنه' },
      };
      if (map[trimmed]) return map[trimmed];
      let match = RELATIONSHIP_DATA_SOURCE.find(
        item => item.name === trimmed || item.value === trimmed
      );
      if (match) return { id: match.id, name: match.name };
      const withoutAl = trimmed.replace(/^ال/, '');
      match = RELATIONSHIP_DATA_SOURCE.find(
        item => item.name === withoutAl || item.value === withoutAl
      );
      if (match) return { id: match.id, name: match.name };
      return { id: null, name: trimmed };
    },
    mapHeirsData(apiData) {
      return apiData.map((item, index) => {
        const relationship = this.resolveRelationship(item.relationToDeceasedName);
        const status = this.resolveHeirStatus(item.statusId, item.statusName, item.genderId);
        return {
          heirGender: item.genderId,
          heirGenderName: item.gender,
          deceasedRelationship: relationship.id,
          deceasedRelationshipName: relationship.name,
          heirName: item.fullName,
          idNumber: item.socialId,
          birthDate: item.dateOfBirth,
          heirCondition: status.key,
          heirConditionName: status.name,
          issuerSubGrid: null,
          instrumentNumberSubGrid: null,
          dateSubGrid: null,
          heirsSubGrid: null,
          objectKey: item.personId,
          number: index + 1,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>